import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import { useForm } from '../../lib/useForm'
import postObject from '../../lib/postObject';

const PricingCreateModal = ({ closeMainModal, reload }) => {
  const [prices, handleChange] = useForm({ priceFrom: '', priceTo: '', rewardPercent: '', moveitPercentFromTravelerReward: '', deliveryFees: '' })
  const [saveLoading, toggleSaveLoading] = useState(false)

  const savePrice = async () => {
    toggleSaveLoading(true)

    postObject('prices', prices).then(() => {
      toggleSaveLoading(false)
      if (typeof reload === 'function') {
        reload()
      }
      closeMainModal()
    });
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Pricing</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={() => closeMainModal()}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Input
            name='priceFrom'
            label='Price From'
            type="number"
            placeholder=''
            value={prices['priceFrom']}
            onChange={handleChange}
          />

          <Form.Input
            name='priceTo'
            label='Price To'
            type="number"
            placeholder=''
            value={prices['priceTo']}
            onChange={handleChange}
          />

          <Form.Input
            name='rewardPercent'
            label='Reward Percentage'
            type="number"
            placeholder=''
            value={prices['rewardPercent']}
            onChange={handleChange}
          />

          <Form.Input
            name='moveitPercentFromTravelerReward'
            label='Fees Percentage'
            type="number"
            placeholder=''
            value={prices['moveitPercentFromTravelerReward']}
            onChange={handleChange}
          />
          <Form.Input
            name='deliveryFees'
            label='Delivery Fees'
            type="number"
            placeholder=''
            value={prices['deliveryFees']}
            onChange={handleChange}
          />
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            type="submit"
            onClick={savePrice}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={() => closeMainModal()}
            disabled={saveLoading}
          >
            cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  )
}

export default PricingCreateModal;